import { baseApi } from "@/api/baseApi";
import type { DocumentMapResponse } from "@/types/document-map";

export const documentMapApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getFolderDocumentMap: builder.query<DocumentMapResponse, string>({
      query: folderFseId => ({
        url: `/pf-mainweb/document/contract-families/folders/${encodeURIComponent(folderFseId)}/document-map`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetFolderDocumentMapQuery } = documentMapApi;
